module.exports = __webpack_public_path__ + "img/poly-4.ad768ec9.png";